import { skipFavoriteDances } from "../api.js";

export async function skip(eventId, { dancerId, occurrenceDate }) {
  return skipFavoriteDances(eventId, { dancerId, occurrenceDate });
}
